// Preserve uncertain submissions across route changes and tab reloads.
// Resource IDs are globally unique; the backend also binds the user/account.
const pending = new Map();
const storageKey = (id) => `alphasearch:saved-search-submission:${id}`;

function readIntents(id) {
  let stored = pending.get(String(id)) || {};
  try { stored = JSON.parse(sessionStorage.getItem(storageKey(id))) || stored; } catch (_error) { /* Mounted-session fallback. */ }
  // Recover uncertain submissions written by the earlier single-intent adapter.
  return stored.fingerprint && stored.key ? {[stored.fingerprint]: stored.key} : stored;
}

function writeIntents(id, intents) {
  pending.set(String(id), intents);
  try {
    if (Object.keys(intents).length) sessionStorage.setItem(storageKey(id), JSON.stringify(intents));
    else sessionStorage.removeItem(storageKey(id));
  } catch (_error) { /* Mounted-session fallback. */ }
}

export function savedSearchSubmissionIntent(id, payload) {
  const fingerprint = JSON.stringify({query: payload.query, title: payload.title || null,
    provider: payload.llm_provider || null, model: payload.model || null,
    company_ids: payload.company_ids ? [...new Set(payload.company_ids)].sort() : null});
  const intents = readIntents(id);
  if (intents[fingerprint]) return intents[fingerprint];
  const key = window.crypto.randomUUID();
  writeIntents(id, {...intents, [fingerprint]: key});
  return key;
}

export function settleSavedSearchSubmissionIntent(id, response, submittedKey) {
  const code = response?.data?.detail?.error_code;
  const accepted = response?.status === 200 && (response.data?.batch_id || response.data?.status === "empty");
  const refused = code === "SUBMISSION_FAILED"
    || ([400, 402, 409, 422].includes(response?.status) && code !== "SUBMISSION_PENDING");
  if ((!accepted && !refused) || !submittedKey) return;
  writeIntents(id, Object.fromEntries(Object.entries(readIntents(id)).filter(([, key]) => key !== submittedKey)));
}
